import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Navigation from './navigation';
import * as Strings from '../constants';


export default () => (
  <header className="App-header">
    <Navigation />
    <Row>
      <Col className="pageTitle">
        <h1>
          {Strings.Title}
        </h1>
      </Col>
      <Col>
        <p className="slogan">
          {Strings.Slogan_1stPar}<br /> <br />{Strings.Slogan_2ndPar}
        </p>
      </Col>
    </Row>
  </header>
);



// WEBPACK FOOTER //
// ./src/components/header.js